/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AlertApiConfiguration } from '../alert-api-configuration';
import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';

import { GetMeta$Params } from '../fn/meta/get-meta';
import { Metadata } from '../models/metadata';

/**
 * Meta API
 */
@Injectable({ providedIn: 'root' })
export class MetaService extends BaseService {
   constructor(config: AlertApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getMeta()` */
   static readonly GetMetaPath = '/api/alert/meta';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getMeta()` instead.
    *
    * This method doesn't expect any request body.
    */
   getMeta$Response(params?: GetMeta$Params, context?: HttpContext): Observable<StrictHttpResponse<Metadata>> {
      return of({} as any);
   }

   getMeta(params?: GetMeta$Params, context?: HttpContext): Observable<Metadata> {
      return of({} as any);
   }
}
